function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import cx from 'classnames';
import Close from "../../icon-components/close";
var customStyles = {
  overlay: {
    backgroundColor: 'rgba(75, 75, 75, 0.74902)'
  }
};
/**
 * This is the modal component, it uses [react-modal](http://reactcommunity.org/react-modal/).
 */

var Modal = function Modal(_ref) {
  var className = _ref.className,
      children = _ref.children,
      isOpen = _ref.isOpen,
      headerLabel = _ref.headerLabel,
      onRequestClose = _ref.onRequestClose,
      footer = _ref.footer,
      zIndex = _ref.zIndex,
      shouldCloseOnOverlayClick = _ref.shouldCloseOnOverlayClick,
      hideModal = _ref.hideModal,
      props = _objectWithoutProperties(_ref, ["className", "children", "isOpen", "headerLabel", "onRequestClose", "footer", "zIndex", "shouldCloseOnOverlayClick", "hideModal"]);

  customStyles.overlay.zIndex = zIndex;
  return React.createElement(ReactModal, _extends({
    className: cx(className, 'ReactModal'),
    isOpen: isOpen,
    style: customStyles,
    onRequestClose: onRequestClose,
    contentLabel: "Modal",
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
    ariaHideApp: false,
    bodyOpenClassName: "ReactModal-body-open"
  }, props), React.createElement("div", {
    className: "ReactModal-content"
  }, headerLabel && React.createElement("header", {
    className: "ReactModal-header"
  }, React.createElement("div", {
    className: "ReactModal-close",
    onClick: hideModal || onRequestClose
  }, React.createElement(Close, null)), React.createElement("h4", {
    className: "ReactModal-header-text"
  }, headerLabel)), React.createElement("div", {
    className: "ReactModal-body"
  }, children), footer && React.createElement("div", {
    className: "ReactModal-footer"
  }, footer)));
};

Modal.displayName = 'Modal';
Modal.propTypes = {
  /**
   * Extended className, passed on to the root ReactModal object
   */
  className: PropTypes.string,

  /**
   * The modal body
   */
  children: PropTypes.any,

  /**
   * isOpen, dictate if the modal is open or not
   */
  isOpen: PropTypes.bool.isRequired,

  /**
   * onRequestClose, this is not called onClose because it is animated
   */
  onRequestClose: PropTypes.func.isRequired,

  /**
   * Controls whether clicking on the overlay will close the modal or not
   */
  shouldCloseOnOverlayClick: PropTypes.bool,

  /**
   * The label shown in the header
   */
  headerLabel: PropTypes.string,

  /**
   * The content of the footer
   */
  footer: PropTypes.any,

  /**
   * zIndex of the modal
   */
  zIndex: PropTypes.number,

  /**
   * Use this function if you want to add modal transition, by default onRequestClose is triggered is this is not defined
   */
  hideModal: PropTypes.func
};
Modal.defaultProps = {
  shouldCloseOnOverlayClick: true,
  zIndex: 3
};
export default Modal;